import { Outlet } from "react-router-dom";
import { AdminNav } from "@/components/admin/admin-nav";

export function AdminLayout() {
  return (
    <div className="min-h-screen bg-background">
      <AdminNav />
      <main className="mx-auto max-w-7xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
